namespace GeniuzPOS.Common.Models {
    export interface PIDCard extends Serenity.ServiceRequest {
        CitizenID?: string;
        ThaiFullName?: string;
        ThaiTitletName?: string;
        ThaiFristName?: string;
        ThaiMiddleName?: string;
        ThaiLastName?: string;
        EnglishName?: string;
        EnglishTitleName?: string;
        EnglishFirstName?: string;
        EnglishMiddleName?: string;
        EnglishLastName?: string;
        BirthDate?: string;
        HouseNo?: string;
        VillageNo?: string;
        Lane?: string;
        Road?: string;
        Tambol?: string;
        Amphur?: string;
        Province?: string;
        Sex?: string;
        ExpireDate?: string;
    }
}
